<template>
  <div class="card">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">Couriers</h4>
              </div><!--col-->
          </div><!--row-->

          <div class="row mt-4">
              <div class="col">
                  <div class="table-responsive">
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Courier Name</th>
                            <th>Incoterm</th>
                            <th>Fuel Surcharge (%)</th>
                            <th>Currency</th>
                            <th>Lead Time</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(courier, index) in couriers" :key="index">
                            <td>{{ courier.name }}</td>
                            <td>{{ courier.incoterm_type }}</td>
                            <td>{{ courier.fuel_surcharge_percent }}</td>
                            <td>{{ courier.currency }}</td>
                            <td>{{ courier.lead_time }}</td>
                            <td>
                              <span class="badge badge-success" v-if="courier.status">Active</span>
                              <span class="badge badge-secondary" v-else>InActive</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                  </div>
              </div><!--col-->
          </div><!--row-->
      </div><!--card-body-->
  </div><!--card-->
</template>

<script>
export default {
  name: 'couriers',
  mounted () {
    this.axios.get('/courier').then(response => {
      this.couriers = response.data
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      couriers: []
    }
  }
}
</script>
